import { useContext, useState, useEffect } from 'react';

import { fetchClientes, fetchUsuarioClientes } from './clientesApi';
import { UserContext } from '../../auth/context/UserContext';

const useClientes = (token, id, filter) => {
  const [clientes, setClientes] = useState([]);
  const [usuarioClientes, setUsuarioClientes] = useState([]);
  const { dataUser } = useContext(UserContext);

  useEffect(() => {
    const loadClientes = async () => {
      const clientesData = await fetchClientes(token, filter);
      setClientes(clientesData);
    };

    loadClientes();
  }, [token, filter]);

  useEffect(() => {
    const loadUsuarioClientes = async () => {
      const usuarioClientesData = await fetchUsuarioClientes(
        token,
        id,
        dataUser.id
      );
      setUsuarioClientes(usuarioClientesData);
    };

    loadUsuarioClientes();
  }, [token, id, dataUser]);

  return { clientes, setClientes, usuarioClientes, setUsuarioClientes };
};

export default useClientes;
